import { MenuItem, Select, Stack } from "@mui/material";
import { type FC } from "react";
import { useForm } from "../../helpers/forms/FormProvider";
import { type Opportunity } from "@entities";

const selectProps = {
  slotProps: {
    root: { className: "field" },
  },
  MenuProps: {
    disableScrollLock: true,
    PaperProps: {
      sx: {
        borderRadius: "20px",
      },
    },
  },
};

export const UrgencySelect: FC = () => {
  const { values, setValues } = useForm<Partial<Opportunity>>();

  return (
    <>
      <Stack className="field-container">
        <label className="field-label">דחיפות</label>
        <Select
          {...selectProps}
          value={values.callCenterUrgency ?? 0}
          onChange={(event) => {
            setValues((draft) => {
              draft.callCenterUrgency = Number(event.target.value);
            });
          }}
        >
          {Array.from({ length: 11 }, (_, value) => (
            <MenuItem key={value} value={value}>
              {value === 0 ? "0 - ללא" : String(value)}
            </MenuItem>
          ))}
        </Select>
      </Stack>
      <Stack className="field-container">
        <label className="field-label">רמת קושי</label>
        <Select
          {...selectProps}
          value={values.callCenterDifficulty ?? 3}
          onChange={(event) => {
            setValues((draft) => {
              draft.callCenterDifficulty = Number(event.target.value);
            });
          }}
        >
          {[1, 2, 3, 4, 5].map((value) => (
            <MenuItem key={value} value={value}>
              {value === 1 || value === 2
                ? `${value} - קלה`
                : value === 3
                  ? "3 - בינונית"
                  : `${value} - קשה`}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </>
  );
};
